<template>
  <div :style="containerStyle" :class="{ dragging: isDragging }" class="pa-0 ma-0">
    <!-- left column -->
    <div :style="leftStyle" class="pa-0 ma-0">
      <slot name="left" />
    </div>
    <!-- separator -->
    <div v-if="isHorizontal" ref="separator" class="separator" @mousedown="startDrag" @touchstart="startDrag">
      <div style="display: flex; gap: 5px; justify-content: center; height: 28px;">
        <div style="background-color: #B1CCCF; width: 2px;"/>
        <div style="background-color: #B1CCCF; width: 2px;"/>
      </div>
    </div>
    <!-- right column -->
    <div :style="rightStyle" class="pa-0 ma-0">
      <slot name="right" />
    </div>
  </div>
</template>

<script>
export default {
  props: ["forceHorizontal", "left"],
  data() {
    return {
      leftWidth: this.left || 60,
      minWidth: 10,
      minRightWidth: 10,
      isDragging: false
    };
  },
  computed: {
    isHorizontal() {
      if (this.forceHorizontal) {
        return true;
      }

      const dpr = window.devicePixelRatio || 1;
      const baseThreshold = this.$vuetify.display.thresholds.lg;
      const adjustedThreshold = baseThreshold * Math.max(1, dpr); // Scale up for high DPI

      return this.$vuetify.display.width >= adjustedThreshold;
    },
    containerStyle() {
      return {
        display: this.isHorizontal ? 'flex' : 'block',
        width: '100%'
      };
    },
    leftStyle() {
      return {
        width: this.isHorizontal ? this.leftWidth +  "% !important" : "100% !important",
      };
    },
    rightStyle() {
      let rightWidth = 100 - this.leftWidth;
      let style = {
        width: this.isHorizontal ? rightWidth + "% !important" : "100% !important",
        marginTop: this.isHorizontal ? '' : '6px !important',
      };
      if (this.isHorizontal) {
        style.flex = '1 1 auto';
        style.minWidth = 0;
      }
      return style;
    }
  },
  methods: {
    startDrag(e) {
      if (!this.isHorizontal) return;
      this.isDragging = true;
      e.stopPropagation();
      const startX = e.clientX || e.touches?.[0]?.clientX;
      const startLeftWidth = this.leftWidth;
      const containerWidth = this.$el.offsetWidth;

      const separatorEl = this.$refs.separator;
      const computedStyle = getComputedStyle(separatorEl);
      const sepWidth = separatorEl.offsetWidth + parseFloat(computedStyle.marginLeft) + parseFloat(computedStyle.marginRight);
      const separatorPercent = (sepWidth / containerWidth) * 100;

      const onMove = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const clientX = e.clientX || e.touches?.[0]?.clientX;
        const deltaX = clientX - startX;

        const deltaPercent = (deltaX / containerWidth) * 100;
        let newWidth = startLeftWidth + deltaPercent;

        newWidth = Math.max(this.minWidth, newWidth);
        newWidth = Math.min(100 - this.minRightWidth - separatorPercent, newWidth);

        this.leftWidth = newWidth;
      };

      const onEnd = () => {
        this.isDragging = false;
        document.removeEventListener('mousemove', onMove);
        document.removeEventListener('touchmove', onMove);
        document.removeEventListener('mouseup', onEnd);
        document.removeEventListener('touchend', onEnd);
      };

      document.addEventListener('mousemove', onMove);
      document.addEventListener('touchmove', onMove, {passive: false});
      document.addEventListener('mouseup', onEnd);
      document.addEventListener('touchend', onEnd);
    }
  }
};
</script>

<style scoped>
  .separator {
    flex: 0 0 10px;
    cursor: col-resize;
    display: flex;
    margin-inline: 16px;
    justify-content: center;
    align-items: flex-start;
    padding-top: 5px;
  }
  .dragging {
    user-select: none;
  }
</style>